define.alias("ember-drag-sort/components/drag-sort-item", "calendar/components/drag-sort-item");